import { render, staticRenderFns } from "./v-badge.vue?vue&type=template&id=8ef1ef62"
import script from "./v-badge.vue?vue&type=script&lang=js"
export * from "./v-badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef1ef62')) {
      api.createRecord('8ef1ef62', component.options)
    } else {
      api.reload('8ef1ef62', component.options)
    }
    module.hot.accept("./v-badge.vue?vue&type=template&id=8ef1ef62", function () {
      api.rerender('8ef1ef62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/badge/v-badge.vue"
export default component.exports